import { useQuery } from '@tanstack/react-query';

import fetch from './fetch';

function useBankList() {
  const { cb, key } = fetch();

  const { data, isLoading, isSuccess, isError, refetch } = useQuery(key, cb, {
    refetchOnWindowFocus: false,
    cacheTime: 1000 * 60 * 10,
    staleTime: 1000 * 60 * 10,
  });

  return { data, isLoading, isSuccess, isError, refetch };
}

export default useBankList;
